var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: [_vm.inputLabel ? "form-group" : ""] }, [
    _vm.inputLabel
      ? _c("label", { staticClass: "control-label name column-nowrap" }, [
          _c("div", { staticClass: "label-form" }, [
            _c("div", { staticClass: "label-title" }, [
              _vm._v(
                "\n                " + _vm._s(_vm.inputLabel) + "\n            "
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", [
      _c("div", { staticClass: "input-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.date,
              expression: "date",
            },
          ],
          ref: "input",
          staticClass: "form-control placeholder-no-fix wes-input-date-picker",
          class: _vm.inputClass,
          attrs: {
            type: "text",
            maxlength: "10",
            id: _vm.inputId,
            placeholder: "dd/mm/aaaa",
            pattern:
              "([0-9]{2})[\\\\\\/\\.\\-]([0-9]{2})[\\\\\\/\\.\\-]([0-9]{4})",
            "data-date-format": "dd/mm/yyyy",
            "data-type": "date",
          },
          domProps: { value: _vm.date },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.date = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "input-group-btn" }, [
      _c(
        "button",
        { staticClass: "btn btn-default", attrs: { type: "button" } },
        [_c("i", { staticClass: "fa fa-calendar" })]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }